import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from './auth.interceptor';
import { BlobErrorInterceptor } from './blobError.interceptor';
import { ErrorInterceptor } from './error.interceptor';
import { HTTPListener } from './http.interceptor';
import { UserInactiveErrorInterceptor } from './user-inactive-error.interceptor';

// Http interceptor providers in outside-in order
export const httpInterceptorProviders = [
  // not in use
  // HTTPStatus,
  // { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
  // { provide: HTTP_INTERCEPTORS, useClass: TenantDomainInterceptor, multi: true },
  // { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },

  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: UserInactiveErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HTTPListener, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: BlobErrorInterceptor, multi: true },
];
